/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { editor, MarkerSeverity, Uri } from "monaco-editor/esm/vs/editor/editor.api";

const syntaxes = [
  "https://bentley.com",
  "/{username}/{sandbox-name}",
  "/{username}/{sandbox-name}/{file-name}",
  "/{username}/{sandbox-name}/{file-name}?start=[number]",
  "/{username}/{sandbox-name}/{file-name}?start=[number]&end=[number]",
  "../{your-sandbox-name}",
  "../{your-sandbox-name}/{file-name}",
  "../{your-sandbox-name}/{file-name}?start=[number]",
  "../{your-sandbox-name}/{file-name}?start=[number]&end=[number]",
  "./{file-name}",
  "./{file-name}?start=[number]",
  "./{file-name}?start=[number]&end=[number]",
];

export const validateLinks = (fileName: string): boolean => {
  const model = editor.getModel(Uri.parse(fileName));
  if (model) {
    editor.setModelMarkers(model, "link_validation", []);
    const value = model.getValue();
    const lines = value.split("\n");
    const markers: editor.IMarkerData[] = [];
    lines.forEach((line, index) => {
      const link = line.match(/!?\[(?:[^\]\\])*\]\(([^)]+)\)/);
      if (link && link[1]) {
        if (!/^https?:/i.test(link[1]) && !/^\/[a-z0-9]+\/.*/i.test(link[1]) && !/^\.\.\/.+\/[a-z0-9.?=]+$/i.test(link[1]) && !/^\.\/[a-z0-9.?=]+$/i.test(link[1])) {
          markers.push({
            severity: MarkerSeverity.Error,
            message: "Invalid Link. Link must follow one of the following syntaxes:\n    ".concat(syntaxes.join("\n    ")),
            startLineNumber: index + 1,
            endLineNumber: index + 1,
            startColumn: link.index || 1,
            endColumn: link[0].length + 1,
          });
        }
      }
    });
    editor.setModelMarkers(model, "link_validation", markers);
    return markers.length <= 0;
  }
  return false;
};
